import { CountryFilterOptionInformation } from '@studyportals/search-filters';
import { Country } from './Country';
import FiltersDataPresenter from '@/study-search/presenters/FiltersDataPresenter';

class CountryFilterOptionInformationFactory {
	private filtersDataPresenter = FiltersDataPresenter;
	private countryFilterOptionInformation: CountryFilterOptionInformation[] = [];

	public getCountryFilterInformation(): CountryFilterOptionInformation[] {
		const countries = this.filtersDataPresenter.getCountries();
		this.countryFilterOptionInformation = this.generateCountryFilterOptionInformation(countries);

		return this.countryFilterOptionInformation;
	}

	public getCountryFilterOptionValues(): string[] {
		return this.countryFilterOptionInformation.map((_) => _.optionValue);
	}

	private generateCountryFilterOptionInformation(countries: Country[]): CountryFilterOptionInformation[] {
		return countries.map(
			(_) => new CountryFilterOptionInformation(_.name, _.identity, _.path, _.name, _.hasAreas, _.eea)
		);
	}
}

export default new CountryFilterOptionInformationFactory();
